module.exports = __webpack_public_path__ + "static/media/astronaut.c9056b4b.png";